import React from 'react';
import { render } from 'react-dom';
import Application from './components/Application';

render(<Application />, document.getElementById('winem8-root'));
